"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
var _SocialSignin = _interopRequireDefault(require("./components/SocialSignin"));
var _user = require("@/api/user");
var _ResetPassword = _interopRequireDefault(require("./components/ResetPassword"));
var _auth = require("@/utils/auth");
var _location = require("@/utils/location");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "Login",
  components: {
    SocialSign: _SocialSignin.default,
    ResetPassword: _ResetPassword.default
  },
  data: function data() {
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!value) {
        callback(new Error("Username is required"));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (!value) {
        callback(new Error("Password is required"));
      } else {
        callback();
      }
    };
    return {
      username: "",
      resetToken: "",
      statusForm: "login",
      loginForm: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [{
          required: true,
          trigger: "submit",
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: "submit",
          validator: validatePassword
        }]
      },
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {}
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        var query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true
    }
  },
  created: function created() {
    // window.addEventListener('storage', this.afterQRScan)
  },
  mounted: function mounted() {
    if (this.loginForm.username === "") {
      this.$refs.username.focus();
    } else if (this.loginForm.password === "") {
      this.$refs.password.focus();
    }
    this.checkResetPassword();
  },
  destroyed: function destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    resetSuccess: function resetSuccess() {
      this.statusForm = "login";
      this.loginForm.username = this.username;
    },
    checkResetPassword: function checkResetPassword() {
      var _this = this;
      if (this.$route.query.token) {
        (0, _user.checkResetPassword)(this.$route.query.token).then(function (res) {
          if (res.status) {
            _this.resetToken = res.data[0].resetToken;
            _this.username = res.data[0].username;
            _this.statusForm = "reset";
          } else {
            _this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    checkCapslock: function checkCapslock() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        shiftKey = _ref.shiftKey,
        key = _ref.key;
      if (key && key.length === 1) {
        if (shiftKey && key >= "a" && key <= "z" || !shiftKey && key >= "A" && key <= "Z") {
          this.capsTooltip = true;
        } else {
          this.capsTooltip = false;
        }
      }
      if (key === "CapsLock" && this.capsTooltip === true) {
        this.capsTooltip = false;
      }
    },
    showPwd: function showPwd() {
      var _this2 = this;
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(function () {
        _this2.$refs.password.focus();
      });
    },
    handleLogin: function handleLogin() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var resultLocation;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.$refs.loginForm.validate();
            case 2:
              _this3.loading = true;
              _context.prev = 3;
              _context.next = 6;
              return _this3.$store.dispatch("user/login", _this3.loginForm);
            case 6:
              _context.next = 8;
              return _this3.$store.dispatch("user/getInfo");
            case 8:
              if (!(_this3.$store.state.user.agencyLevel == 4)) {
                _context.next = 16;
                break;
              }
              _context.next = 11;
              return (0, _location.getLocation)();
            case 11:
              resultLocation = _context.sent;
              if (resultLocation) {
                _context.next = 16;
                break;
              }
              _this3.$message.error("Please allow access location in your setting system!");
              (0, _auth.removeToken)();
              return _context.abrupt("return");
            case 16:
              _this3.$router.push({
                path: _this3.redirect || "/",
                query: _this3.otherQuery
              });
              _context.next = 22;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](3);
              (0, _auth.removeToken)();
            case 22:
              _context.prev = 22;
              _this3.loading = false;
              return _context.finish(22);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 19, 22, 25]]);
      }))();
    },
    getOtherQuery: function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    } // afterQRScan() {
    //   if (e.key === 'x-admin-oauth-code') {
    //     const code = getQueryObject(e.newValue)
    //     const codeMap = {
    //       wechat: 'code',
    //       tencent: 'code'
    //     }
    //     const type = codeMap[this.auth_type]
    //     const codeName = code[type]
    //     if (codeName) {
    //       this.$store.dispatch('LoginByThirdparty', codeName).then(() => {
    //         this.$router.push({ path: this.redirect || '/' })
    //       })
    //     } else {
    //       alert('第三方登录失败')
    //     }
    //   }
    // }
  }
};